module.exports = __webpack_public_path__ + "img/nav02.06291c1d.png";